// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__10G_c","image":"App_image__2bPXS"};